import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginRedirectionService } from '../../sso/Services/login-redirection.service';
import { AllApiService } from '../../sso/Services/all-api.service';
import { ToastrService } from 'ngx-toastr';
import { SsoAuthService } from '../../sso/Services/sso-auth.service';
import { IdleTimerService } from '../../sso/Services/idle-timer.service';

@Component({
  selector: 'app-signin-load',
  imports: [],
  templateUrl: './signin-load.component.html',
  styleUrl: './signin-load.component.scss'
})
export class SigninLoadComponent {
  constructor(
    private router: Router,
    private activeroute: ActivatedRoute,
    private ssologinredirect: LoginRedirectionService,
    private ssoapi: AllApiService,
    private toaster: ToastrService,
    private authService: SsoAuthService,
    private idleTimerService: IdleTimerService
  ) { }


  ngOnInit() {
    const token = localStorage.getItem('AccessToken');
    const codeVerifier = localStorage.getItem('sso_code_verifier');

    this.activeroute.queryParams.subscribe((params) => {
      const accessCode = params['accessCode'];
      if (accessCode) {
        localStorage.setItem('accessCode', accessCode);
        const codeVerifier = localStorage.getItem('sso_code_verifier');
        if (!codeVerifier) {
          this.toaster.error('Something Went Wrong!')
          this.ssologinredirect.loginredirection()
          return;
        }
        const payload = {
          code: accessCode,
          codeVerifier: codeVerifier,
        };

        this.ssoapi.getAccessToken(payload).subscribe({
          next: (response: any) => {
            // console.log('Access Token API Response:', response);

            // this.toaster.success(response.message || 'Login Successful!');
            // localStorage.setItem('userToken', response.data.token);
            // localStorage.setItem('isLoggedIn', 'true');
            // this.authService.initTimer();

            // this.idleTimerService.startWatching(() => {
            //   console.log('Logging out due to inactivity...');
            //   this.authService.logOut();
            // });
            // this.router.navigateByUrl('/accomodation/regularbooking');
            // sessionStorage.setItem(
            //   'profileDetails',
            //   JSON.stringify(response.data.profileDetails)
            // );
            if (!response.error) {
              if (response.data) {
                let obj = {
                  userName: response?.data.fullName,
                  familyCode: response?.data.familyCode,
                  // memberCode: response?.data.memberCode,
                  showAllTransactions: response?.data.showUserAllTransactions,
                };
                localStorage.setItem('UserDetails', JSON.stringify(obj));
              }
              if (response.data.token) {
                localStorage.setItem('AccessToken', response.data.token);
              }
              if (response.data.permissons) {
                localStorage.setItem(
                  'permissons',
                  JSON.stringify(response.data.permissons)
                );
              }
              console.log('LOGIN', response.data.permissons);
              this.authService.initTimer();

              this.idleTimerService.startWatching(() => {
                console.log('Logging out due to inactivity...');
                this.authService.logOut(false);
              });
              this.router.navigate(['/new-deposit']);
            }


          },
          error: (error: any) => {
            console.error('Access Token API Error:', error);
            this.toaster.error(
              error.msg || 'Something went wrong while logging in!'
            );
          },
        });
      } else {
        if (token) {
          this.router.navigateByUrl('/new-deposit');
        } else {
          setTimeout(() => {
            this.ssologinredirect.loginredirection();
          }, 1000);
        }
      }
    });
  }
}
